'use client';

import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '~/utils';

interface PopoverProps extends React.ComponentProps<typeof PopoverPrimitive.Root> {}

export const Popover: React.FC<PopoverProps> = ({ ...props }) => {
    return <PopoverPrimitive.Root data-slot="popover" {...props} />;
};

interface PopoverTriggerProps extends React.ComponentProps<typeof PopoverPrimitive.Trigger> {}

export const PopoverTrigger: React.FC<PopoverTriggerProps> = ({ ...props }) => {
    return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
};

interface PopoverContentProps extends React.ComponentProps<typeof PopoverPrimitive.Content> {
    align?: 'center' | 'start' | 'end';
    container?: HTMLElement | null;
}

export const PopoverContent: React.FC<PopoverContentProps> = ({
    className,
    align = 'center',
    sideOffset = 4,
    container,
    ...props
}) => {
    return (
        <PopoverPrimitive.Portal container={container}>
            <PopoverPrimitive.Content
                data-slot="popover-content"
                align={align}
                sideOffset={sideOffset}
                className={cn(
                    'origin-\\[var\\(--radix-popover-content-transform-origin\\)\\] z-popovers w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                    className,
                )}
                {...props}
            />
        </PopoverPrimitive.Portal>
    );
};

interface PopoverAnchorProps extends React.ComponentProps<typeof PopoverPrimitive.Anchor> {}

export const PopoverAnchor: React.FC<PopoverAnchorProps> = ({ ...props }) => {
    return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
};
